import ActionsForm from '@/shared/mixins/actionsForm'
import AprActivitiesRepository from '@/shared/http/repositories/business/aprActivities'
import { loading, toast } from '@/shared/utils/UIHelper'
import collapseEditApr from '@/views/private/apr/registerApr/components/collapseapr/components/collapseEditApr/collapseEditApr.vue'
import collapseAddApr from '@/views/private/apr/registerApr/components/collapseapr/components/collapseAddApr/collapseAddApr.vue'

export default {
  name: 'collapseApr',
  props: {
    formSearch: {
      type: Object,
      requered: false
    }
  },
  mixins: [ActionsForm],
  components: {collapseEditApr, collapseAddApr},
  data () {
    return {
      changeAngel: false,
      templatesLista: [],
      columTemplate: ['DESCRIÇÃO'],
      arquivoCarregamento: false,
      teste: [
        'ATIVIDADES',
        'DESCRICÃO ATIVIDADE',
        'TIPOS DE RISCOS',
        'CAUSA OU NATUREZA DO RISCO',
        'CONSEQUÊNCIAS',
        'RISCOS ESPECIAIS',
        'CURSOS NR',
        'EQUIPAMENTO DE PROTEÇÃO INDIVIDUAL',
        'MEDIDAS DE CONTROLE/MITIGADORAS',
        'FONTE GERADORA',
        'FERRAMENTAS',
        'ETAPA DE SERVIÇO'
      ],
      itemArray: [],
      openSections: [],
      lista: [],
      listAtividades: {
        nome: 'ATIVIDADES',
        categoria: 0,
        list: []
      },
      listTipoRisco: {
        nome: 'TIPOS DE RISCOS',
        categoria: 1,
        list: []
      },
      listCausa: {
        nome: 'CAUSA OU NATUREZA DO RISCO',
        categoria: 2,
        list: []
      },
      listConsequencias: {
        nome: 'CONSEQUÊNCIAS',
        categoria: 3,
        list: []
      },
      listRiscoEspeciais: {
        nome: 'RISCOS ESPECIAIS',
        categoria: 4,
        list: []
      },
      listCursoNR: {
        nome: 'CURSOS NR',
        categoria: 5,
        list: []
      },
      listEPI: {
        nome: 'EQUIPAMENTO DE PROTEÇÃO INDIVIDUAL',
        categoria: 6,
        list: []
      },
      listMedidasControle: {
        nome: 'MEDIDAS DE CONTROLE/MITIGADORAS',
        categoria: 7,
        list: []
      },
      listFonteGeradora: {
        nome: 'FONTE GERADORA',
        categoria: 8,
        list: []
      },
      listDescricaoAtividade: {
        nome: 'DESCRIÇÃO ATIVIDADE',
        categoria: 9,
        list: []
      },
      listFerramentas: {
        nome: 'FERRAMENTAS',
        categoria: 10,
        list: []
      },
      listEtapaServico: {
        nome: 'ETAPA DE SERVIÇO',
        categoria: 11,
        list: []
      },
      form: {},
      formAdd: {
        Nome: '',
        Categoria: 0,
        CodigoAtividade: null,
        DataAlteracao: '',
        Descricao: '',
        Id: null
      },
      listavazia: {
        categoria: 0
      },
      titlePopup: '',
      EditOrAdd: false,
      nomeLista: '',
      deleteDescricao: {},
      formTeste: null,
      categoriaNomeEdit: null,
      categoriaNomeAdd: null
    }
  },
  mounted () {
    // this.arrayActivities()
    // this.onLoad()
  },
  methods: {
    onLoad () {
      this.lista = []
      let form = this.formSearch
      if (form.Listagem !== undefined && form.Listagem !== null && form.Listagem.length !== 0) {
        form.Listagem.forEach((e) => {
          if (e.categoria === 0) {
            this.getAllActivities(form)
          }
          if (e.categoria === 1) {
            this.getAllTypeRisks(form)
          }
          if (e.categoria === 2) {
            this.getAllReason(form)
          }
          if (e.categoria === 3) {
            this.getAllConsequences(form)
          }
          if (e.categoria === 4) {
            this.getAllSpecialRisks(form)
          }
          if (e.categoria === 5) {
            this.getAllCourseNR(form)
          }
          if (e.categoria === 6) {
            this.getAllEquipamentoProtecaoIndividual(form)
          }
          if (e.categoria === 7) {
            this.getAllMedidasControle(form)
          }
          if (e.categoria === 8) {
            this.getAllFonteGeradora(form)
          }
          if (e.categoria === 9) {
            this.getAllDescricaoAtividade(form)
          }
          if (e.categoria === 10) {
            this.getAllFerramentas(form)
          }
          if (e.categoria === 11) {
            this.getAllServiceStage(form)
          }
        })
        this.lista.forEach(item => {
          this.itemArray.push(item)
        })
        this.lista.sort((a, b) => a.nome.localeCompare(b.nome))
      } else {
        this.getAllCategories(this.formSearch)
      }
    },
    async getAllCategories (obj) {
      await this.getAllActivities(obj)
      await this.getAllTypeRisks(obj)
      await this.getAllReason(obj)
      await this.getAllConsequences(obj)
      await this.getAllSpecialRisks(obj)
      await this.getAllCourseNR(obj)
      await this.getAllEquipamentoProtecaoIndividual(obj)
      await this.getAllMedidasControle(obj)
      await this.getAllFonteGeradora(obj)
      await this.getAllDescricaoAtividade(obj)
      await this.getAllFerramentas(obj)
      await this.getAllServiceStage(obj)
      this.lista.forEach(item => {
        this.itemArray.push(item)
      })
      this.lista.sort((a, b) => a.nome.localeCompare(b.nome))
    },
    async getAllActivities (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllActivities({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listAtividades.list = Response.data.data
            this.lista.push(
              this.listAtividades
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllTypeRisks (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllTypeRisks({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listTipoRisco.list = Response.data.data
            this.lista.push(
              this.listTipoRisco
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllReason (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllReasons({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listCausa.list = Response.data.data
            this.lista.push(
              this.listCausa
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllConsequences (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllConsequences({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listConsequencias.list = Response.data.data
            this.lista.push(
              this.listConsequencias
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllSpecialRisks (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllSpecialRisks({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listRiscoEspeciais.list = Response.data.data
            this.lista.push(
              this.listRiscoEspeciais
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllCourseNR (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllCourseNR({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listCursoNR.list = Response.data.data
            this.lista.push(
              this.listCursoNR
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllEquipamentoProtecaoIndividual (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllEquipamentoProtecaoIndividual({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listEPI.list = Response.data.data
            this.lista.push(
              this.listEPI
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllMedidasControle (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllMedidasControle({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listMedidasControle.list = Response.data.data
            this.lista.push(
              this.listMedidasControle
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllFonteGeradora (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllFonteGeradora({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listFonteGeradora.list = Response.data.data
            this.lista.push(
              this.listFonteGeradora
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllDescricaoAtividade (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllDescricaoAtividade({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listDescricaoAtividade.list = Response.data.data
            this.lista.push(
              this.listDescricaoAtividade
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllFerramentas (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllFerramentas({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listFerramentas.list = Response.data.data
            this.lista.push(
              this.listFerramentas
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    async getAllServiceStage (value) {
      loading.push()
      if (value === undefined) {
        value = {
          Descricao: null
        }
      }
      await AprActivitiesRepository.GetAllServiceStage({descricao: value === undefined ? null : value.Descricao})
        .then(Response => {
          if (((value.Descricao !== null || value.Descricao !== undefined) && Response.data.data.length > 0) || (value.Descricao === null || value.Descricao === undefined)) {
            this.listEtapaServico.list = Response.data.data
            this.lista.push(
              this.listEtapaServico
            )
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    changeAcording (value) {
      this.changeAngel = !this.changeAngel
      this.arquivoCarregamento = !this.arquivoCarregamento
    },
    recolherTodos () {
      this.openSections = []
    },
    expandirTodos () {
      this.openSections = this.lista.map((data, index) => index)
    },
    toggleSection (index) {
      const i = this.openSections.indexOf(index)
      if (i === -1) {
        this.openSections.push(index)
      } else {
        this.openSections.splice(i, 1)
      }
    },
    popUpEdit (value, obj) {
      this.form = {}
      this.categoriaNomeEdit = obj.nome
      this.EditOrAdd = false
      this.titlePopup = 'Editar Informações'
      this.$refs['edit-cadastro'].show()
      this.form = value
    },
    popUpAdd (value, obj) {
      this.categoriaNomeAdd = null
      if (value !== undefined) {
        this.categoriaNomeAdd = obj
        this.formAdd.descricao = null
        this.formAdd.categoria = value
        this.EditOrAdd = true
        this.titlePopup = 'Adicionar Informações'
        this.$refs['add-cadastro'].show()
      } else {
        toast.error('Erro ao gerar cadastro!')
      }
    },
    popUpDelete (obj, data) {
      this.lista = []
      this.deleteDescricao = {}
      this.deleteDescricao = obj
      this.nomeLista = data
      this.$refs['delete-cadastro'].show()
    },
    fechaPopAtualizaGrid () {
      this.$refs['edit-cadastro'].hide()
    },
    fechaPopAddGrid () {
      this.$refs['add-cadastro'].hide()
    },
    fechaPopDeleteGrid () {
      this.$refs['delete-cadastro'].hide()
    },
    async salvaEditarCadastroBasico (value) {
      loading.push()
      if (value !== undefined) {
        value.Descricao = this.$refs.collapseEditApr.internalForm.descricao
        AprActivitiesRepository.EditTemplate(value).then(Response => {
          this.lista = []
          this.getAllCategories()
          toast.success('Alteraçao realizada com sucesso')
          this.$refs['edit-cadastro'].hide()
          loading.pop()
        }).catch(Error => {
          toast.error('Não foi possível cadastrar, existe registro com mesma descrição')
          loading.pop()
        })
      } else {
        toast.error('Não foi possível realizar a edição')
      }
    },
    async salvaAdicaoCadastroBasico (value) {
      this.formAdd.Categoria = value.categoria
      this.formAdd.CodigoAtividade = value.codigoAtividade
      this.formAdd.DataAlteracao = value.dataAlteracao
      this.formAdd.Descricao = value.descricao
      this.formAdd.Id = value.id
      loading.push()
      if (value !== undefined) {
        AprActivitiesRepository.AddTemplate(this.formAdd)
          .then(Response => {
            this.lista = []
            this.getAllCategories()
            toast.success('Alteraçao realizada com sucesso')
            this.$refs['add-cadastro'].hide()
            loading.pop()
          }).catch(Error => loading.pop())
      } else {
        toast.error('Não foi possível realizar a criação')
        loading.pop()
      }
    },
    async DeleteCadastroBasico (value) {
      loading.push()
      AprActivitiesRepository.DeleteTemplate(value)
        .then(Response => {
          console.log(Response)
          if (Response.data.length > 0) {
            loading.pop()
            this.lista = []
            this.templatesLista = Response.data
            this.getAllCategories()
            this.$refs['delete-cadastro'].hide()
            this.$refs['impossibilitado-exclusao'].show()
          } else {
            loading.pop()
            this.lista = []
            this.getAllCategories()
            toast.success('Registro excluído com sucesso')
            this.$refs['delete-cadastro'].hide()
          }
        }).catch(Error => {
          loading.pop()
          toast.error('Não foi possível de excluir')
        })
    },
    fechaPopTemplates () {
      this.$refs['impossibilitado-exclusao'].hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/registerApr/components/collapseapr/collapseApr.js